(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7c47"];
var parcelRegister = parcelRequire.register;
parcelRegister("7aIXE", function(module, exports) {
const $538c57f0ebb915a9$var$generateGalleryId = (gallerySelector, galleryLinkSelector, postfix = "I")=>{
    const galleries = document.querySelectorAll(gallerySelector);
    let galleryId = `gallery-${postfix}`;
    galleries.forEach((gallery)=>{
        const links = gallery.querySelectorAll(galleryLinkSelector);
        links.forEach((link)=>{
            link.setAttribute("data-fancybox", galleryId);
        });
        galleryId += postfix;
    });
};
const $538c57f0ebb915a9$var$init = ()=>{
    $538c57f0ebb915a9$var$generateGalleryId(".gallery", ".gallery-icon a");
    $538c57f0ebb915a9$var$generateGalleryId(".wp-block-gallery", ".blocks-gallery-item a", "W");
    $538c57f0ebb915a9$var$generateGalleryId(".g-gallery", ".i-gallery__img", "gg");
};
window.addEventListener("fancybox-reinit", $538c57f0ebb915a9$var$init);
$538c57f0ebb915a9$var$init();

});

})();
//# sourceMappingURL=fancybox-gallery-id-generator.dd6215c4.js.map
